<template>
  <div>
    <!-- no-close-on-backdrop
      no-close-on-esc -->
    <b-modal
      ref="modal-setting-role"
      :title="$t(getTitleModal)"
      modal-class="modal-primary"
      hide-footer
      @hidden="$emit('hideModal')"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div>
        <ValidationObserver ref="ref-validation-role">
          <b-row>
            <!-- Code -->
            <b-col lg="12" md="12" sm="12">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="code"
              >
                <b-form-group :label="$t('Code')" label-for="code">
                  <b-form-input
                    id="code"
                    v-model="form.code"
                    :state="errors[0] ? false : null"
                    type="text"
                    v-mask="'XXX'"
                  ></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </b-col>

            <!-- Name -->
            <b-col lg="12" md="12" sm="12">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                name="name"
              >
                <b-form-group :label="$t('Name')" label-for="name">
                  <b-form-input
                    id="name"
                    v-model="form.name"
                    :state="errors[0] ? false : null"
                    type="text"
                    v-mask="'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'"
                  ></b-form-input>
                </b-form-group>
              </ValidationProvider>
            </b-col>
            <!-- Modules -->
            <b-col lg="12" md="12" sm="12">
              <b-form-group :label="$t('Modules')" label-for="modules">
                <v-select
                  id="modules"
                  v-model="selectedModules"
                  multiple
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="modulesOptions"
                  :reduce="(val) => val.id"
                  @option:deselected="deselectedOption($event)"
                  @input="inputSelectModule"
                />
              </b-form-group>
            </b-col>

            <!-- Permissions Table -->
            <b-col lg="12" md="12" sm="12" v-if="availableModulesOptions.length > 0">
              <div v-for="(option, index) in availableModulesOptions" :key="option.id" class="mb-2 border rounded p-1">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <h6 class="mb-0 font-weight-bold text-primary">{{ $t(option.label) }}</h6>
                  <b-form-checkbox
                    @change="selectAllSection($event, option.id)"
                  >
                    {{ $t('Select All') }}
                  </b-form-checkbox>
                </div>
                <b-table-simple small responsive class="mt-1">
                  <b-thead head-variant="dark">
                    <b-tr>
                      <b-th>{{ $t('Section') }}</b-th>
                      <b-th class="text-center">{{ $t('View') }}</b-th>
                      <b-th class="text-center">{{ $t('Create') }}</b-th>
                      <b-th class="text-center">{{ $t('Update') }}</b-th>
                      <b-th class="text-center">{{ $t('Delete') }}</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr v-for="section in option.section" :key="section.value">
                      <b-td>{{ $t(section.text) }}</b-td>
                      <b-td class="text-center">
                        <b-form-checkbox
                          :checked="hasPermission(section.value, 'can_view')"
                          @change="togglePermission(section.value, 'can_view')"
                        />
                      </b-td>
                      <b-td class="text-center">
                        <b-form-checkbox
                          :checked="hasPermission(section.value, 'can_create')"
                          @change="togglePermission(section.value, 'can_create')"
                        />
                      </b-td>
                      <b-td class="text-center">
                        <b-form-checkbox
                          :checked="hasPermission(section.value, 'can_update')"
                          @change="togglePermission(section.value, 'can_update')"
                        />
                      </b-td>
                      <b-td class="text-center">
                        <b-form-checkbox
                          :checked="hasPermission(section.value, 'can_delete')"
                          @change="togglePermission(section.value, 'can_delete')"
                        />
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>
            </b-col>
          </b-row>
        </ValidationObserver>
      </div>
      <div class="text-center mt-1">
        <b-button @click="saveRole" variant="outline-success">{{
          $t("SAVE")
        }}</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BModal,
  BSkeletonTable,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
  BFormCheckbox,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { mapGetters } from "vuex";
import modalMixin from "@/mixins/modal";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import RolesAreaService from "@/views/settings/views/roles-area/service/roles-area.service.js";
import UserServices from "@/views/users/services/users.service";
export default {
  mixins: [modalMixin],
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BSkeletonTable,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    flatPickr,
  },
  props: {
    roleId: {
      required: true,
    },
  },
  data() {
    return {
      form: {
        id: null,
        code: null,
        name: null,
        sections: [],
      },
      modulesOptions: [],
      selectedModules: [],
      selectedSections: [],
    };
  },
  mounted() {
    this.toggleModal("modal-setting-role");
  },
  async created() {
    // await this.getAreas();
    // await this.getDiscountTypes();
    try {
      this.addPreloader();
      await this.getModules();
      if (this.roleId != null) {
        this.form.id = this.roleId;
        await this.getRoleById();
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.removePreloader();
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    routeName() {
      return this.$route.name;
    },
    availableModulesOptions() {
      const options = this.modulesOptions.filter(
        (op) => this.selectedModules.indexOf(op.id) != -1
      );
      return options;
    },
  },
  methods: {
    async getRoleById() {
      try {
        const params = { id: this.roleId };
        const { data } = await RolesAreaService.getRoleById(params);

        this.form.code = data[0].code;
        this.form.name = data[0].name;

        // Populate sections and derived modules
        this.selectedSections = data[0].sections || [];
        const moduleIds = [];
        this.selectedSections.forEach((s) => {
          this.modulesOptions.forEach((mod) => {
            if (mod.section && mod.section.find((sec) => sec.value == s.id)) {
              if (!moduleIds.includes(mod.id)) moduleIds.push(mod.id);
            }
          });
        });
        this.selectedModules = moduleIds;
        this.inputSelectModule();
      } catch (error) {
        console.log(error);
      }
    },
    async getModules() {
      try {
        const { data } = await UserServices.getModules();
        this.modulesOptions = data;
      } catch (error) {
        console.log(error);
      }
    },
    hasPermission(sectionId, type) {
      const section = this.selectedSections.find((s) => s.id === sectionId);
      if (!section) return false;
      return !!section[type];
    },
    togglePermission(sectionId, type) {
      const index = this.selectedSections.findIndex((s) => s.id === sectionId);
      if (index !== -1) {
        this.selectedSections[index][type] = this.selectedSections[index][type]
          ? 0
          : 1;

        const s = this.selectedSections[index];
        if (!s.can_view && !s.can_create && !s.can_update && !s.can_delete) {
          this.selectedSections.splice(index, 1);
        }
      } else {
        const newSection = {
          id: sectionId,
          can_view: 0,
          can_create: 0,
          can_update: 0,
          can_delete: 0,
        };
        newSection[type] = 1;
        if (type !== "can_view") newSection.can_view = 1;

        this.selectedSections.push(newSection);
      }
    },
    selectAllSection(event, moduleId) {
      const module = this.modulesOptions.find((option) => option.id == moduleId);
      const sectionsId = module.section.map((element) => element.value);

      for (let i = 0; i < sectionsId.length; i++) {
        const sectionId = sectionsId[i];
        const index = this.selectedSections.findIndex((s) => s.id === sectionId);

        if (event == true) {
          if (index === -1) {
            this.selectedSections.push({
              id: sectionId,
              can_view: 1,
              can_create: 1,
              can_update: 1,
              can_delete: 1,
            });
          } else {
            this.selectedSections[index].can_view = 1;
            this.selectedSections[index].can_create = 1;
            this.selectedSections[index].can_update = 1;
            this.selectedSections[index].can_delete = 1;
          }
        } else {
          if (index !== -1) {
            this.selectedSections.splice(index, 1);
          }
        }
      }
    },
    deselectedOption(event) {
      const sections = event.section;
      const newSections = [];
      this.selectedSections.map((row) => {
        const exist = sections.find((row2) => row2.value == row.id);
        if (!exist) {
          newSections.push(row);
        }
      });
      this.selectedSections = newSections;
    },
    inputSelectModule() {
      // Nothing special needed here for now
    },
    async saveRole() {
      try {
        const result = await this.$refs["ref-validation-role"].validate();
        if (!result) return;

        const confirm = await this.showConfirmSwal();
        if (confirm.isConfirmed) {
          this.addPreloader();
          this.form.user_id = this.currentUser.id;
          this.form.sections = this.selectedSections;
          const { data } = await RolesAreaService.saveRole(this.form);
          if (data.type == "success") {
            this.showToastSuccess(data.message, "Success");
            this.$emit("refreshTable");
          }
        }
      } catch (error) {
        console.log(error);
        this.showToastError(
          error?.response?.data || error?.response?.data?.message
        );
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style lang="scss">
</style>